import { render, staticRenderFns } from "./PriceTableDetail.vue?vue&type=template&id=007ddb77&"
import script from "./PriceTableDetail.vue?vue&type=script&lang=js&"
export * from "./PriceTableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports